/*
 * copied from https://github.com/imbhargav5/rooks/blob/master/packages/shared/useKeyRef.ts
 */
import { useEffect, useCallback, useRef, useMemo } from 'react';
var defaultOptions = {
    when: true,
    eventTypes: ['keydown'],
};
/**
 * useKey hook
 *
 * Fires a callback on keyboard events like keyDown, keyPress and keyUp
 *
 * @param {[string|number]} input
 * @param {function} callback
 * @param {Options} opts
 */
function useKey(input, callback, opts) {
    var keyList = useMemo(function () { return (Array.isArray(input) ? input : [input]); }, [input]);
    var options = Object.assign({}, defaultOptions, opts);
    var when = options.when, eventTypes = options.eventTypes;
    var callbackRef = useRef(callback);
    var target = options.target;
    useEffect(function () {
        callbackRef.current = callback;
    });
    var handle = useCallback(function (e) {
        if (keyList.some(function (k) { return e.key === k || e.code === k; })) {
            callbackRef.current(e);
        }
    }, [keyList]);
    useEffect(function () {
        if (when && typeof window !== 'undefined') {
            var targetNode_1 = target ? target['current'] : window;
            eventTypes.forEach(function (eventType) {
                if (targetNode_1) {
                    targetNode_1.addEventListener(eventType, handle);
                }
            });
            return function () {
                eventTypes.forEach(function (eventType) {
                    if (targetNode_1) {
                        targetNode_1.removeEventListener(eventType, handle);
                    }
                });
            };
        }
    }, [when, eventTypes, keyList, target, callback]);
}
export { useKey };



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/hooks/UseKey.tsx
// module id = 166
// module chunks = 0